import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import styled, { useTheme } from 'styled-components';
import { CommonLayer } from '../../helpers/layers.esm.js';
import { useBodyScrollLock } from '../../hooks/useBodyScrollLock/useBodyScrollLock.esm.js';
import { Flex } from '../Layout/Layout.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  height: 100dvh;\n  top: 0;\n  left: 0;\n  justify-content: center;\n  align-items: center;\n  z-index: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var _dialog_backdropStyle;
var StyledBackdrop = styled(Flex)(_templateObject(), CommonLayer.DialogBackground, function(param) {
    var dialog = param.dialog;
    return (_dialog_backdropStyle = dialog === null || dialog === void 0 ? void 0 : dialog.backdropStyle) !== null && _dialog_backdropStyle !== void 0 ? _dialog_backdropStyle : "background-color: rgba(0, 0, 0, 0.5);";
});
var Backdrop = function(_param) {
    var _param_disablesBodyScroll = _param.disablesBodyScroll, disablesBodyScroll = _param_disablesBodyScroll === void 0 ? true : _param_disablesBodyScroll, props = _object_without_properties(_param, [
        "disablesBodyScroll"
    ]);
    var ref = useRef(null);
    var theme = useTheme();
    useBodyScrollLock({
        defaultActive: disablesBodyScroll,
        element: ref.current
    });
    return /*#__PURE__*/ jsx(StyledBackdrop, _object_spread({
        dialog: theme.dialog,
        ref: ref
    }, props));
};

export { Backdrop };
